"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = __importDefault(require("classnames"));
const InputGroup_1 = __importDefault(require("components/cosmos/InputGroup"));
const InputSearch_module_scss_1 = __importDefault(require("./InputSearch.module.scss"));
const InputSearch = ({ className, ...rest }) => {
    return ((0, jsx_runtime_1.jsxs)(InputGroup_1.default, { className: (0, classnames_1.default)(className, InputSearch_module_scss_1.default.wrapper), children: [(0, jsx_runtime_1.jsx)("input", { className: (0, classnames_1.default)('hot-form__input', InputSearch_module_scss_1.default.input), ...rest }), (0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)('hot-input-group__prepend', InputSearch_module_scss_1.default.icon), children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'search'] }) })] }));
};
exports.default = InputSearch;
